import ax from '../axios'
import {API_URL} from "../index";

const STORY_URL = API_URL.EDUCATION_MODULE + '/story'

const getStories = (query: string) => {
    return ax.get(`${STORY_URL}/search?${query}&hiddenstoryfortag=removeEducation`)
}
const getCategories = (query: string) => {
    return ax.get(`${STORY_URL}/categories?${query}`)
}
const getStoryDetail = (query: string) => {
    return ax.get(`${STORY_URL}/detail?${query}`)
}
const getStoryPages = (query: string) => {
    return ax.get(`${STORY_URL}/pages?maxPageCount=1000&${query}`)
}

export {
    getStories,
    getStoryPages,
    getStoryDetail,
    getCategories
}
